import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Divider, Row, Space, theme, Typography } from 'antd'
import React from 'react'

export const PageHeader = ({ title, icon }) => {
  const { token } = theme.useToken()
  const { Title, Text } = Typography
  return (
    <>
      <Row align='middle' justify='center' style={{ paddingBottom: 8 }}>
        <Col>
          <Space align='center'>
            <div
              style={{
                background: 'rgba(24, 144, 255, 0.1)',
                borderRadius: '50%',
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FontAwesomeIcon
                icon={icon}
                style={{
                  fontSize: 20,
                  color: token.colorPrimary
                }}
              />
            </div>
            <div>
              <Title level={4} style={{ margin: 0, lineHeight: 1.2 }}>
                {title}
              </Title>
            </div>
          </Space>
        </Col>
      </Row>
      <Divider style={{ margin: '0 0 0 0' }} />
    </>
  )
}

export default PageHeader
